import { jsx as _jsx } from "react/jsx-runtime";
import { CloseOutlined } from "@ant-design/icons";
import { Button } from "../../Button/Button";
const RemoveButton = (props) => {
    return (_jsx(Button, Object.assign({ icon: _jsx(CloseOutlined, { style: { fontSize: 12 } }), type: "text" }, props)));
};
export default RemoveButton;
